/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Import Bootstrap and BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

import moment from 'moment';

import { Form, HasError, AlertError } from 'vform';
window.Form = Form;

import Gate from "./Gate";
Vue.prototype.$gate = new Gate(window.user);

import Swal from 'sweetalert2';
import 'vuejs-dialog/dist/vuejs-dialog.min.css';

import VuejsDialog from 'vuejs-dialog';
Vue.use(VuejsDialog);

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    onOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  })
window.Swal = Swal;
window.Toast = Toast;

import VueProgressBar from 'vue-progressbar'
Vue.use(VueProgressBar, {
    color: 'rgb(143, 255, 199)',
    failedColor: 'red',
    height: '3px'
});

Vue.use(require('vue-chunks'));

import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyDXgQZikhJ6Q5yX-bxv92d0dvxndcPnCEk',
        libraries: 'places', // This is required if you use the Autocomplete plugin
    },
});

import VueImageLightboxCarousel from 'vue-image-lightbox-carousel'
Vue.use(VueImageLightboxCarousel);

import Lingallery from 'lingallery';
Vue.use(Lingallery);

Vue.component(HasError.name, HasError)
Vue.component(AlertError.name, AlertError)

//event listener

Vue.prototype.$eventHub = new Vue();
Vue.prototype.$userId = document.querySelector("meta[name='user_id']").getAttribute('content');
Vue.prototype.$admin = document.querySelector("meta[name='admin']").getAttribute('content');
Vue.prototype.$agent = document.querySelector("meta[name='agent_id']").getAttribute('content');
Vue.prototype.$slug = document.querySelector("meta[name='slug']").getAttribute('content');

/**
 * Routes imports and assigning
 */
import VueRouter from 'vue-router';
Vue.use(VueRouter);
import routes from './routes';

const router = new VueRouter({
    mode: 'history',
    routes
});
// Routes End


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */


// Components
Vue.component('pagination', require('laravel-vue-pagination'));
Vue.component('dashboard', require('./components/Dashboard.vue'));

Vue.component(
    'autocomplete',
    require('./components/autocomplete/Autocomplete.vue').default
);

Vue.component(
    'not-found',
    require('./components/NotFound.vue').default
);

Vue.component(
    'browse',
    require('./components/site/Browse.vue').default
);

Vue.component(
    'listing',
    require('./components/site/Listing.vue').default
);

Vue.component(
    'contact-us',
    require('./components/site/ContactUs.vue').default
);

Vue.component(
    'filters',
    require('./components/site/Filters.vue').default
);

Vue.component(
    'agent-profile',
    require('./components/AgentProfile.vue').default
);

Vue.component(
    'agent-edit',
    require('./components/AgentEdit.vue').default
);

Vue.component(
    'agent-listing-add',
    require('./components/AgentListingAdd.vue').default
);

Vue.component(
    'agent-listing-edit',
    require('./components/AgentListingEdit.vue').default
);

Vue.component(
    'calculator',
    require('./components/site/Calculator.vue').default
);

Vue.component(
    'write-testimonial',
    require('./components/site/WriteTestimonial.vue').default
);

Vue.component(
    'image-create',
    require('./components/ImageCreate.vue').default
);

Vue.component(
    'agent-links',
    require('./components/AgentLinks.vue').default
);

Vue.component(
    'create-resource-link',
    require('./components/CreateResourceLink.vue').default
);

Vue.component(
    'edit-resource-link',
    require('./components/EditResourceLink').default
);

Vue.component(
    'filters',
    require('./components/FiltersSidebar').default
);

Vue.component(
    'listing',
    require('./components/Listing').default
);

Vue.component(
    'join-our-team-modal',
    require('./components/JoinOurTeamModal').default
);

Vue.component(
    'jumbotron-component',
    require('./components/JumbotronComponent').default
);


Vue.component('search-component', require('./components/SearchComponent.vue').default);
// Filter Section

Vue.filter('myDate',function(created){
    return moment(created).format('MMMM Do YYYY');
});

Vue.filter('toCurrency', function (value) {
    if (typeof value !== "number") {
        value = parseInt(value);
    }

    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    });
    return formatter.format(value);
});

Vue.filter('yesno', value => (value ? '<i class="fas fa-check green"></i>' : '<i class="fas fa-times red"></i>'));

// end Filter

Vue.component('example-component', require('./components/ExampleComponent.vue'));


import VueEditor from "vue2-editor";
Vue.use(VueEditor)

const app = new Vue({
    el: '#app',
    router
});
